export default "__VITE_ASSET__DaWGVIJi__"